import { Box, CircularProgress, RadioGroup, Divider } from "@mui/material";
import { IMarketplace } from "../../../../interfaces/IMarketplace";
import { RadioCard } from "../../../../../core/components/RadioCard";
import { TipoCobrancaEntrega, TipoCobrancaEntregaDescricao, TipoCobrancaEntregaTitulo } from "../../../../../pedidos/enum/TipoCobrancaEntrega";
import { TipoFormularioEndereco } from "../../../../../pedidos/enum/TipoFormularioEndereco";
import { useState, useEffect } from "react";
import { useMarketplaces } from "../../../../hooks/useMarketplaces";

interface TipoCobrancaEntregaContainerProps {
    marketplace: IMarketplace;
    refresh: () => void;
}

export const TipoCobrancaEntregaContainer = ({ marketplace, refresh }: TipoCobrancaEntregaContainerProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [tipoFormulario, setTipoFormulario] = useState<TipoFormularioEndereco>(
        marketplace?.configuracao?.tipoFormularioEndereco ?? TipoFormularioEndereco.PADRAO
    );
    const { salvar } = useMarketplaces();

    useEffect(() => {
        if (marketplace?.configuracao?.tipoFormularioEndereco) {
            setTipoFormulario(marketplace.configuracao.tipoFormularioEndereco);
        }
    }, [marketplace]);

    const handleTipoCobranca = async (tipo: TipoCobrancaEntrega) => {
        setLoading(true);
        const tipoFormularioParaEnviar = tipo === TipoCobrancaEntrega.DISTANCIA ? tipoFormulario : undefined;
        await salvar({
            ...marketplace,
            configuracao: {
                ...marketplace.configuracao,
                tipoCobrancaEntrega: tipo,
                tipoFormularioEndereco: tipoFormularioParaEnviar
            }
        });
        setTimeout(() => {
            refresh();
            setLoading(false);
        }, 1500)
    }

    const handleTipoFormulario = async (tipo: TipoFormularioEndereco) => {
        setLoading(true);
        setTipoFormulario(tipo);
        await salvar({
            ...marketplace,
            configuracao: {
                ...marketplace.configuracao,
                tipoCobrancaEntrega: marketplace.configuracao?.tipoCobrancaEntrega,
                tipoFormularioEndereco: tipo
            }
        });
        setTimeout(() => {
            refresh();
            setLoading(false);
        }, 1500)
    }

    if(loading) {
        return (
            <Box sx={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '5rem',
                marginBottom: '5rem',
            }}>
                <CircularProgress size={50} />
            </Box>
        );
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 0 }}>
            <RadioGroup
                name="tipo-cobranca-entrega"
                row
                sx={{ display: "flex", justifyContent: "flex-start", gap: '2rem', width: "100%" }}
                onChange={(e) => handleTipoCobranca(e.target?.value as TipoCobrancaEntrega)}
            >
                <RadioCard
                    labelTitle={TipoCobrancaEntregaTitulo.DISTANCIA}
                    labelDescription={TipoCobrancaEntregaDescricao.DISTANCIA}
                    labelValue={TipoCobrancaEntrega.DISTANCIA}
                    key={TipoCobrancaEntrega.DISTANCIA}
                    selected={marketplace?.configuracao?.tipoCobrancaEntrega == TipoCobrancaEntrega.DISTANCIA}
                    onClick={() => handleTipoCobranca(TipoCobrancaEntrega.DISTANCIA)}
                />
                <RadioCard
                    labelTitle={TipoCobrancaEntregaTitulo.REGIAO}
                    labelDescription={TipoCobrancaEntregaDescricao.REGIAO}
                    labelValue={TipoCobrancaEntrega.REGIAO}
                    key={TipoCobrancaEntrega.REGIAO}
                    selected={marketplace?.configuracao?.tipoCobrancaEntrega == TipoCobrancaEntrega.REGIAO}
                    onClick={() => handleTipoCobranca(TipoCobrancaEntrega.REGIAO)}
                />
            </RadioGroup>
            {marketplace?.configuracao?.tipoCobrancaEntrega == TipoCobrancaEntrega.DISTANCIA && (
                <>
                    <Divider sx={{ my: 2 }} />
                    <RadioGroup
                        name="tipo-formulario-endereco"
                        row
                        sx={{ display: "flex", justifyContent: "flex-start", gap: '2rem', width: "100%" }}
                        value={tipoFormulario}
                        onChange={(e) => handleTipoFormulario(e.target?.value as TipoFormularioEndereco)}
                    >
                        <RadioCard
                            labelTitle="Formulário Padrão"
                            labelDescription="Formulário tradicional com campos separados"
                            labelValue={TipoFormularioEndereco.PADRAO}
                            key={TipoFormularioEndereco.PADRAO}
                            selected={tipoFormulario == TipoFormularioEndereco.PADRAO}
                            onClick={() => handleTipoFormulario(TipoFormularioEndereco.PADRAO)}
                        />
                        <RadioCard
                            labelTitle="Google Autocomplete"
                            labelDescription="Busca de endereço com Google Places"
                            labelValue={TipoFormularioEndereco.GOOGLE_AUTOCOMPLETE}
                            key={TipoFormularioEndereco.GOOGLE_AUTOCOMPLETE}
                            selected={tipoFormulario == TipoFormularioEndereco.GOOGLE_AUTOCOMPLETE}
                            onClick={() => handleTipoFormulario(TipoFormularioEndereco.GOOGLE_AUTOCOMPLETE)}
                        />
                    </RadioGroup>
                </>
            )}
        </Box>
    );
}